import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import OrganizationFunctionsService from "src/modules/data-protection/apis/OrganizationFunctionsService";
import { ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY } from "src/modules/data-protection/constants/organizationFunctions";

import {
    extractFunctions,
    mapFunctionsToOptions,
} from "../helpers";

const useUserFunctionsSelect = (t) => {
    const functionsQuery = useQuery({
        queryKey: ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY,
        queryFn: async () => {
            const service = OrganizationFunctionsService.getInstance();
            const data = await service.list();

            return extractFunctions(data);
        },
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching functions."), {
                type: "error",
            });
        },
    });

    const functions = functionsQuery.data || [];

    return {
        functions,
        options: mapFunctionsToOptions(functions),
        isLoading: functionsQuery.isFetching,
        isFetched: functionsQuery.isFetched,
    };
};

export default useUserFunctionsSelect;
